<template>
  <div class="wapBottom">
    <div class="wap-bottom-logo">
      <img class="wap-logo" src="../assets/logo_2@2x.png" alt="春阳台logo" />
    </div>
    <div class="wap-line"></div>

    <div class="wap-bottom-info">
      <div
        class="links"
        :class="showInfo ? 'showCopyright' : 'hideCopyright'"
        @click="showInfo = !showInfo"
      >
        {{ isEnglish ? 'About Us' : '关于我们' }}
      </div>
      <div class="copyright" v-if="showInfo">
        <div>{{ currentContactInfo.address }}</div>
        <div>{{ currentContactInfo.phone }}</div>
        <div>{{ currentContactInfo.email }}</div>
      </div>
    </div>
    <div class="wap-line"></div>
    
    <div class="wap-bottom-info">
      <div
        class="links"
        :class="showContact ? 'showCopyright' : 'hideCopyright'"
        @click="showContact = !showContact"
      >
        {{ isEnglish ? 'Contact Us' : '关注我们' }}
      </div>

      <div class="wap-qr-list" v-if="showContact">
        <img class="show-wap-qr" src="../assets/wap-cyt.png" alt="公众号二维码" />
        <img class="show-wap-qr" src="../assets/wap-xcx.png" alt="小程序二维码" />
        <img class="show-wap-qr" src="../assets/wap-xhs.png" alt="小红书二维码" />
      </div>
    </div>
    <div class="wap-line"></div>

    <div class="bottom-certificate">
      <a
        href="https://beian.miit.gov.cn/#/Integrated/recordQuery"
        target="_self"
        >©️2024 CHUN YANG TAI 粤ICP备2023112445号</a
      >
    </div>
  </div>
</template>

<script>
export default {
  name: 'WapBottom',
  
  data() {
    return {
      lan: this.$store.state.isEn,
      showInfo: false,
      showContact: false,
      contactInfoData: {
        cn: {
          address: '地址：广州市花都区炭步镇朗头村青云路18号',
          phone: '电话：020-22262888',
          email: '邮箱：chunyangtai@langchuanculture.cn'
        },
        en: {
          address: 'Add: NO.18 Qingyun Road, Langtou Village,Tanbu Town, Huadu District, Guangzhou, China',
          phone: 'Tel: 020-22262888',
          email: 'Email: chunyangtai@langchuanculture.cn'
        }
      }
    };
  },
  
  computed: {
    isEnglish() {
      return this.lan === 1;
    },
    
    currentContactInfo() {
      return this.isEnglish ? this.contactInfoData.en : this.contactInfoData.cn;
    }
  },
  
  watch: {
    "$store.state.isEn"(newVal) {
      this.lan = newVal;
    },
  },
};
</script>

<style scoped>
.wapBottom {
  width: 100%;
  z-index: 100;
  background-color: #000;
  background-size: cover;
  min-width: 320px;
}

.wap-bottom-logo {
  padding-top: 30px;
  margin: 0px auto 20px;
  width: 90%;
}

.wap-logo {
  width: 94px;
  height: 36px;
}

.wap-line {
  margin: 0 auto;
  width: 90%;
  height: 1px;
  background-color: #646464;
}

.wap-bottom-info {
  width: 90%;
  margin: 25px auto;
}

.wapBottom .links {
  position: relative;
  font-size: 16px;
  color: #fff;
  font-weight: lighter;
  font-family: SourceHanSansCN-Bold;
  font-weight: 700;
}

.wapBottom .copyright {
  padding-top: 20px;
  font-family: SourceHanSansCN-Regular;
  font-size: 16px;
  color: #98989f;
  line-height: 28px;
  font-weight: 400;
}

.wapBottom .hideCopyright::after {
  content: "";
  position: absolute;
  top: 30%;
  right: 2px;
  width: 8px;
  height: 8px;
  border-top: 4px solid #666;
  border-right: 4px solid #666;
  -webkit-transform: translateY(-45%) rotate(135deg);
  transform: translateY(-45%) rotate(135deg);
  border-top-width: 2px;
  border-top-style: solid;
  border-top-color: #666666;
  border-right-width: 2px;
  border-right-style: solid;
  border-right-color: #666666;
}

.wapBottom .showCopyright::after {
  content: "";
  position: absolute;
  top: 30%;
  right: 2px;
  width: 8px;
  height: 8px;
  border-bottom: 4px solid #666;
  border-left: 4px solid #666;
  -webkit-transform: translateY(45%) rotate(135deg);
  transform: translateY(45%) rotate(135deg);
  border-bottom-width: 2px;
  border-bottom-style: solid;
  border-bottom-color: #666666;
  border-left-width: 2px;
  border-left-style: solid;
  border-left-color: #666666;
}

.wap-qr-list {
  width: 100%;
  text-align: center;
}

.show-wap-qr {
  width: 25%;
  object-fit: contain;
  margin-top: 60px;
}

.show-wap-qr-title {
  display: flex;
  justify-content: center;
  margin: 20px auto 0;
  color: #fff;
  line-height: 28px;
}

.show-wap-qr-title img {
  width: 28px;
  height: 28px;
  margin-right: 12px;
}

.bottom-certificate {
  padding-top: 30px;
  padding-bottom: 32px;
  display: flex;
  justify-content: center;
  width: 98%;
}

.bottom-certificate a {
  font-family: SourceHanSansCN-Regular;
  font-size: 14px;
  color: #98989f;
  font-weight: Regular;
}

@media (max-width: 450px) {
  .wap-bottom-logo {
    padding-top: 25px;
    margin: 0px auto 16px;
    width: 90%;
  }
  
  .wap-logo {
    width: 70px;
    height: 29px;
  }
  
  .wap-bottom-info {
    width: 90%;
    margin: 17px auto;
  }

  .wapBottom .links {
    position: relative;
    font-size: 14px;
    color: #fff;
    font-weight: lighter;
    font-family: SourceHanSansCN-Bold;
    font-weight: 700;
  }
  
  .bottom-certificate a {
    font-size: 12px;
  }
  
  .wapBottom .copyright {
    font-size: 12px;
  }
  
  .wap-qr-list {
    width: 60%;
    margin: 0 auto;
    text-align: center;
  }
  
  .show-wap-qr {
    width: 115px;
    height: 145px;
    object-fit: contain;
    margin-top: 31px;
  }
}
</style>